import React from "react";
import styles from './Radios.module.scss';
import RadioCircle from './components/radioCircleSvg';


export interface IRadioProps {
  setState?: (boolean: boolean) => void;
  labelRight?: string;
  labelLeft?: string;
  state?: boolean;
}

const RadioCircleWithLabel = ({label, state}) => <span className={styles.RadioCircleWithLabel}>
         <RadioCircle
           state={state}
         />
          <span className={styles.label}>{label}</span>
        </span>;

const Radios = (props: IRadioProps) => {
  return (
    <span className={`${styles.Radio}`.trim()}
          onClick={() => props.setState(!props.state)}>

      {[<RadioCircleWithLabel
        key={1}
        label={props.labelRight}
        state={props.state}
      />
        ,
        <span key={2} className={styles.between}>  </span>
        ,
        <RadioCircleWithLabel
          key={3}
          label={props.labelLeft}
          state={!props.state}
        />
      ]}
    </span>
  );
};

Radios.defaultProps = {
  labelRight: '',
  labelLeft: '',
};

export default Radios;
